/**
 * Simple plugin example
 *
*/

'use strict';


// public interface
module.exports = {
    onInit: function ( config, callback ) {
        callback();
    },
    onSettingsInit: function ( config, callback ) {
        require('mag-gettext').load({
            name: core.environment.language,
            path: config.path + 'lang'
        }, function () {
            callback(
                null,
                require('./modules/settings/main')(config)
            );
        });
    }
};
